import { useEffect, useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
//Components
import Delete from "../../components/Delete";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import Details from "../../components/Modals/Promotion/Details";
import UpdatePromotion from "../../components/Modals/Promotion/Update";
import NoData from "../../components/NoData";
import PopMenu from "../../components/PopMenuTable";
import TitleDefault from "../../components/Title/TitleDefault";
import Toast from "../../components/Toast";
import TopActionBar from "../../components/TopActionBar";
import useLoading from "../../hooks/useLoading";
//Icons
import { Circle, List, PencilSimple, Trash } from "@phosphor-icons/react";
import { FiMoreVertical } from "react-icons/fi";
//Hooks
import { useCheckbox } from "../../hooks/useCheckbox";
import { useMultipleModal } from "../../hooks/useMultipleModal";
//utils
import FormatarData from "utils/FormatData";
//Interface
import { IPage } from "Interfaces/IPage";
import { IPromotion } from "Interfaces/IPromotion";

export default function Promotion() {
  const [data, setData] = useState<IPromotion[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } = useCheckbox();
  const [selectAll, setSelectAll] = useState(false);
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
    per_page: 0
  });

  const listHeaderTable = [
    "#",
    "Nome",
    "Produto",
    "Característica",
    "Status",
    "Autorização",
    "Vendedor",
    "Período",
    "Ações"
  ];

  const menuItemsPop = [
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  //Atualizar dados com registro atual de paginação
  const refreshFrames = () => {
    fetchData(page.current_page, page.per_page);
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/promotion?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await axiosInstance.get(url);
      setData(response.data.data);
      setCurrentPage(response.data);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error do Promotion: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm]);

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  };

  //Selecionar todos os ids
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Seleciona todos os IDs
      const newSelectedIds = new Set(data.map((item) => item.id));
      setSelectedIds(newSelectedIds);
    } else {
      // Desmarca todos os IDs
      CleanSelectIds();
    }
  };

  const handleCheckChange = (id: number) => {
    toggleCheckbox(id);
  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  const getColorClass = (feature: number) => {
    switch (feature) {
      case 1: return 'inactive';
      case 2: return 'active';
      case 3: return 'scheduled';
      case 4: return 'blue';
      default: return 'purple';
    }
  };

  const getTypeProdutct = (type: string) => {
    switch (type) {
      case 'App\\Models\\Frame': return 'Armação';
      case 'App\\Models\\Lens': return 'Lente';
      case 'App\\Models\\Service': return 'Serviço';
      case 'App\\Models\\Accessory': return 'Acessório';
      default: return '-';
    }
  }

  return (
    <S.Container>
      <TitleDefault
        filterSearch={handleSearchChange}
        title="Registro de Promoção"
        subtitle="Gerencie as promoções do sistema"
        placeholderSearch="Buscar por nome da promoção"
        fetchData={fetchData}
        titleButton="Novo Desconto"
        modalKey="discount"
        visibleButton={false}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContaintableButton>

            <S.ContentButton>
              {selectedIds.length > 0 && (
                <TopActionBar
                  idSelecteds={selectedIds}
                  typeProduct="acessory"
                  nameDeleteAll="promotion-delete-all"
                  fetchData={fetchData}
                  handleDeleteResponse={handleDeleteResponse}
                  isPromo={false}
                />
              )}
            </S.ContentButton>
            <S.Table>
              <S.THead>
                <S.Tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {listHeaderTable.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </S.Tr>
              </S.THead>

              <S.TBody>
                {
                  data.length > 0 ? (
                    data.map((val, index) => (
                      <S.Tr key={index}>
                        <S.Td>
                          <S.CheckBox
                            onChange={() => handleCheckChange(val.id)}
                            type="checkbox"
                            id={val.title}
                            name={val.title}
                            checked={selectedIds.includes(val.id)}
                          /></S.Td>
                        <S.Td>{(page.current_page - 1) * page.per_page + index + 1}</S.Td>
                        <S.Td>{val.title || "-"}</S.Td>
                        <S.Td>{getTypeProdutct(val.promotion_items[0]?.promotionable_type) || '-'} ({val.promotion_items.length || 0})
                        </S.Td>
                        <S.Td>
                          <S.ContentField>
                            {val.filters.length > 0
                              ? val.filters.map((items, index) => (
                                <S.HighlightedField key={index} className={getColorClass(index + 1)}>
                                  {items.type} {items.name}
                                </S.HighlightedField>
                              ))
                              :
                              <S.HighlightedField className="scheduled">
                                Aleatória
                              </S.HighlightedField>
                            }
                          </S.ContentField>
                        </S.Td>
                        <S.Td>
                          <S.HighlightedField className={
                            val.status === 'Ativa' ?
                              'active' : val.status === 'Inativo' ?
                                'inactive' : 'scheduled'
                          }>
                            <Circle size={8} weight="fill" />
                            {val.status || "-"}
                          </S.HighlightedField>
                        </S.Td>
                        <S.Td>{val.auth || "-"}</S.Td>
                        <S.Td>{val.user?.first_name || "-"}</S.Td>
                        <S.Td>{FormatarData(val.start, 'default-data') || "-"} à {FormatarData(val.end, 'default-data') || "-"}</S.Td>

                        <S.TdPopMenu>
                          <S.ContentPopMenu>
                            <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                              <FiMoreVertical />
                            </S.ButtonTable>
                          </S.ContentPopMenu>
                          {isOpenModal("menu") && openModalOptId === val.id && (
                            <S.PopMenu ref={(ref) => assignRef("menu", ref)}>
                              <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                            </S.PopMenu>
                          )}
                        </S.TdPopMenu>

                      </S.Tr>
                    ))
                  ) : <NoData />
                }
              </S.TBody>
            </S.Table>
          </S.ContaintableButton>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}

      <UpdatePromotion
        isOpenModal={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        refreshFrames={refreshFrames}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <Toast
        openToast={isOpenModal('open-toast')}
        closeToast={() => toggleModalVisibility('open-toast')}
        message={toastData.message}
        status={toastData.status}
      />
      <Details
        isOpenModalDetails={isOpenModal("details")}
        setModalClose={() => toggleModalVisibility("details")}
        selectedUrlId={openModalOptId}
      />

      <Delete
        updateList={refreshFrames}
        endpoint="promotion"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container>
  );
}
